const MobileCutlist = ({ cutlist, index, showcolor }) => {
  return (
    <div className="p-2 position-relative cutlist-row">
      <div className="d-flex flex-wrap align-content-center">
        <span
          className="fw-bold text-white rounded-circle"
          style={{
            fontSize: "12px",
            backgroundColor: "gray",
            padding: "1px 6px 1px 6px",
          }}
        >
          {index + 1}
        </span>
        <span className="mx-3">
          {cutlist.length_1} x {cutlist.length_2}
        </span>
        <span style={{ color: "gray" }}>{cutlist.name}</span>
        <span
          style={{ color: "gray", right: "10px" }}
          className={"position-absolute"}
        >
          {cutlist.thickness + " mm"}
        </span>
      </div>
      <div className="mt-2 px-4 d-flex flex-wrap">
        {showcolor && (
          <span style={{ marginLeft: "10px" }}>
            {cutlist.colors[0]} /{" "}
            {cutlist.colors.length === 2
              ? cutlist.colors[1]
              : cutlist.colors[0]}
          </span>
        )}
        {showcolor && cutlist.edges !== "No EG" && (
          <span className="mx-2 fw-bold"> | </span>
        )}
        <span style={showcolor ? {} : { marginLeft: "12px" }}>
          {cutlist.edges !== "No EG" && cutlist.edges}
        </span>
        {cutlist.grooves && (
          <span
            className="px-1 position-absolute border border-3"
            style={{ right: "10px" }}
          >
            Groove
          </span>
        )}
        {cutlist.grooves && (
          <span
            className="px-1 position-absolute border border-3"
            style={{ right: "40px" }}
          >
            Minifix
          </span>
        )}
      </div>
    </div>
  );
};

export default MobileCutlist;
